import { render } from "./SvgIcons.vue?vue&type=template&id=71547b4c&scoped=true"
import script from "./SvgIcons.vue?vue&type=script&lang=js"
export * from "./SvgIcons.vue?vue&type=script&lang=js"

import "./SvgIcons.vue?vue&type=style&index=0&id=71547b4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71547b4c"]])

export default __exports__